<template>
    <span v-if="!isTag" :class="{empty,prettyText:true}">
        <Icon :class="{empty_animate:this.animateIcon}" v-if="uiicon" :type="uiicon"/>
        <span>{{localize(uitext)}}</span>
    </span>
</template>
<script>
import helper from "@/assets/helper";

export default {
    props: ["text", "icon", 'type'],
    mixins: [{ methods: helper }],
    data() {
        return {
            uitext: this.text,
            uiicon: this.icon,
            animateIcon: false,
            isTag: false,
            empty: false
        };
    },
    watch: {
        text: "update"
    },
    methods: {
        update() {
            if (!this.text) {
                this.empty = true;
                this.uitext = this.$t('Message.uitext');
            } else {
                this.empty = false;
                if (this.type == 2 && this.text == "Const.Material.Status.GetInfo"){
                    this.uitext = "Const.Material.Status.GetAudioInfo"
                }else {
                    this.uitext = this.text;
                }
            }

            this.animateIcon = false;
            switch (this.text) {
                case "Const.Material.Type.Video":
                    this.uiicon = "ios-videocam";
                    break;
                case "Const.Material.Type.Audio":
                    this.uiicon = "ios-musical-notes";
                    break;
                case "Const.Material.Type.Image":
                    this.uiicon = "md-images";
                    break;

                case "Const.Material.Status.Init":
                    this.uiicon = "ios-pause";
                    break;
                case "Const.Material.Status.OssIdle":
                    this.uiicon = "ios-pause";
                    break;
                case "Const.Material.Status.Uploading":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;
                case "Const.Material.Status.Progress":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;
                case "Const.Material.Status.OssUploading":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;
                case "Const.Material.Status.GetInfo":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;
                case "Const.Material.Status.Done":
                    this.uiicon = "md-cloud-done";
                    break;
                case "Const.Material.Status.Defeated":
                    this.uiicon = "md-close-circle";
                    break;
                case "Const.Material.Status.OssDefeated":
                    this.uiicon = "md-close-circle";
                    break;
                case "Const.Material.Status.ProgDefeated":
                    this.uiicon = "md-close-circle";
                    break;

                case "Const.Material.PublishStatus.Init":
                    this.uiicon = "ios-pause";
                    break;
                case "Const.Material.PublishStatus.Defeated":
                    this.uiicon = "ios-close-circle";
                    break;
                case "Const.Material.PublishStatus.Issue":
                    this.uiicon = "ios-cloud-done";
                    break;
                case "Const.Material.PublishStatus.Uploading3":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;
                case "Const.Material.PublishStatus.Uploading4":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;
                case "Const.Material.PublishStatus.Publishing":
                    this.uiicon = "ios-refresh-circle";
                    this.animateIcon = true;
                    break;

                case "Const.Watermark.Type.Image":
                    this.uiicon = "ios-image";
                    break;
                case "Const.Watermark.Type.Text":
                    this.uiicon = "ios-paper";
                    break;

                default:
                    break;
            }
        }
    },
    mounted() {
        this.update();
    }
};
</script>
<style lang="less">
.empty {
    border-radius: 3px;
    padding: 1px 10px;
    color: #aaa;
    background: #f2f2f2;
}
.prettyText {
    & > * {
        /*vertical-align: middle;*/
        margin: 0 1px;
    }
}
@keyframes empty_animate {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.empty_animate {
    animation: empty_animate 3s linear infinite;
}
</style>


